<section>
  <div class="card">
    <div class="card-body">
      <form [formGroup]="deleteHistoryForm">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="Comments" class="required-field">Comments:</label>
            <textarea [rows]="textAreaRows" #comments id="Comments" class="form-control" formControlName="Comments"></textarea>
            <div class="cross-validation-feedback" *ngIf="deleteHistoryForm.get('Comments').invalid">
              Please provide comments.
            </div>
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-active" [disabled]="deleteHistoryForm.invalid" (click)="onSubmit()" value="Submit">Submit</button>
          <button type="button" class="btn btn-secondary" (click)="onCancel()" value="Cancel">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</section>
